import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CachingService } from '../caching.service';
import { CoreApiService, queryAll } from '../core-api.service';
import { ProfileService } from '../profile/profile.service';
import { RequestState } from '../shared/enums/request-state.enum';
import { ReadTaskProtocol } from '../shared/models/read-task-protocol.model';

@Injectable({ providedIn: 'root' })
export class TasksService extends CachingService {
  private readProtocols = {
    state: RequestState.Empty,
    subject: new ReplaySubject<ReadTaskProtocol[]>(1),
    request: this.profileService.exhaustiveMode$.pipe(
      switchMap(exhaustive => {
        return queryAll(this.coreApi.readTaskProtocols.query, exhaustive ? { exhaustive: true } : {}) as Observable<ReadTaskProtocol[]>;
      }),
    ),
  }
  readonly readProtocols$ = this.readProtocols.subject.asObservable()
  readonly refreshTaskList$ = new Subject<void>()
  readonly reloadProject$ = new Subject<void>()

  constructor(
    private coreApi: CoreApiService,
    private profileService: ProfileService,
  ) {
    super();
  }

  getReadProtocols({ refresh = false } = {}): Observable<ReadTaskProtocol[]> {
    return this.getCacheableResource(this.readProtocols, this.readProtocols$, { refresh });
  }
}
